import { type PayOverTimePaymentPlanLineItem } from '@varo/graphql-schema-types';
import { Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLineFormat } from 'shared/components/vxl/ListItem/ListItemTextStack';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

interface PaymentPlanLineItemsProps {
  lineItems: PayOverTimePaymentPlanLineItem[];
}

const PaymentPlanLineItems = ({ lineItems }: PaymentPlanLineItemsProps) => {
  const lastLineItemIndex = lineItems.length - 1;

  return (
    <View>
      {lineItems.map((item, index) => {
        const isTotal = index === lastLineItemIndex;
        return (
          <Fragment key={`line-item-${item.label}`}>
            <ListItem
              primaryCopy={item.label}
              secondaryCopy={item.subLabel ?? undefined}
              lineFormat={
                item.subLabel ? ListItemLineFormat.CAPTION : undefined
              }
              showsChevron={false}
              trailingAccessory={{
                id: `line-item-value-${item.label}`,
                name: VXLComponentId.LIST_ITEM_TEXT_STACK,
                props: {
                  primaryCopy: item.value,
                  boldPrimaryCopy: isTotal,
                },
              }}
              boldPrimaryCopy={isTotal}
            />
            {isTotal ? null : (
              <View style={styles.divider}>
                <HairLineDivider />
              </View>
            )}
          </Fragment>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  divider: { marginHorizontal: theme.spacing.m },
});

export default PaymentPlanLineItems;
